import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsSection = ({ 
  title, 
  description, 
  icon, 
  children, 
  isExpanded = true, 
  onToggle = null,
  className = '' 
}) => {
  return (
    <div className={`bg-surface border border-border rounded-lg shadow-card ${className}`}>
      {/* Section Header */}
      <div 
        className={`flex items-center justify-between p-4 lg:p-6 ${
          onToggle ? 'cursor-pointer hover:bg-muted transition-micro' : ''
        }`}
        onClick={onToggle}
      >
        <div className="flex items-center space-x-3">
          {icon && (
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={icon} size={20} className="text-primary" />
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
            {description && (
              <p className="text-sm text-text-secondary mt-1">{description}</p>
            )}
          </div>
        </div>
        {onToggle && (
          <Icon 
            name={isExpanded ? "ChevronUp" : "ChevronDown"} 
            size={20} 
            className="text-text-secondary" 
          />
        )}
      </div>

      {/* Section Content */}
      {isExpanded && (
        <div className="px-4 pb-4 lg:px-6 lg:pb-6 border-t border-border">
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingsSection;